const rowsPerPageOptions = [5, 10, 25, 50];
const rowsPerPageOptions3x = [6, 9, 12, 24, 48];

/** Shared loading messages for FullScreenOverlayLoader. */
const LOADING_MESSAGES = {
  WEEKLY_PATROL_REPORT: "Loading weekly patrol report...",
  GPS_DATA: "Loading GPS data...",
  DEFAULT: "Loading...",
  UPLOADING_DOCUMENT: "Uploading Document ...",
  PROCESSING_IMAGE: "Processing image...",
  STARTING_CAMERA: "Starting Camera ..."
};

const XLSX_ALL_BORDER_STYLE = {
  top: { style: "thin" },
  left: { style: "thin" },
  bottom: { style: "thin" },
  right: { style: "thin" }
};

const EMAIL_DRAFT_ID_PREFIX = "draft-email:";
// `$(key)` or `$(key).property` in an email subject/body. Global: use with
// matchAll / replace only.
const EMAIL_TOKEN_PATTERN = /\$\(([^)]+)\)(\.\w+)?/g;
const EMAIL_BODY_FORMAT_OPTIONS = {
  indent_size: 2,
  wrap_line_length: 0,
  preserve_newlines: true,
  max_preserve_newlines: 1,
  indent_inner_html: true,
  extra_liners: []
};
const PATROL_EXPORT_DISCLAIMER =
  "The contents of this document, including any personnel, narrative, tables, schedules, appendices, and/or pricing details, contain sensitive confidential and proprietary information specific to LaPrairie Works Inc. (LWI). This information was prepared and is submitted specifically for the purpose of the CMA 519 Contact CON0024164 compliance. The information contained is commercially and strategically sensitive. It provides a direct portal into the commercial / proprietary workings / strategies of LaPrairie Works Inc. Any disclosure of LaPrairie Works Inc.’s related, commercial / proprietary / strategic information, to others outside the Department of Transportation & Economic Corridors, would be detrimental to LaPrairie Works Inc.’s business and would undermine its competitive status within the highly competitive highway maintenance industry. It is LaPrairie Works Inc.’s expectation that its submissions and related information they contain are being provided confidentially to Alberta’s Ministry of Transportation and Economic Corridors and will not be disclosed to others, including LWI’s competitors in the highway maintenance industry subject to the limited and specific exceptions as set out in the FOIP Act.";
const GPS_ROUTE_WINDOW_HOURS = 3;
const GPS_ROUTE_MAX_CONCURRENT_WINDOWS = 6;

export default {
  rowsPerPageOptions,
  rowsPerPageOptions3x,
  LOADING_MESSAGES,
  XLSX_ALL_BORDER_STYLE,
  EMAIL_DRAFT_ID_PREFIX,
  EMAIL_TOKEN_PATTERN,
  PATROL_EXPORT_DISCLAIMER,
  GPS_ROUTE_WINDOW_HOURS,
  GPS_ROUTE_MAX_CONCURRENT_WINDOWS,
  EMAIL_BODY_FORMAT_OPTIONS,
  PATROL_EXPORT_DISCLAIMER
};
